<template>
  <el-table
    :data="(data || []).filter(row => row.visible !== false)"
    @selection-change="selectionChange"
    @sort-change="sortChange"
    :highlight-current-row="highlightRow"
    :border="border"
    ref="table"
    :max-height="maxHeight"
    :show-summary="showSummary"
    :summary-method="getElSummaries"
    :span-method="spanMethod"
    :row-class-name="tableRowClassName"
  >
    <div class="empty" slot="empty">
      <empty/>
    </div>
    <el-table-column v-if="!noIndex" type="index" label="序号" width="50" align="center" fixed>
      <template slot-scope="scope">
        <span v-if="scope.row.type === '成本费用合计' || scope.row.type === '资产合计'">
          <i :class="scope.row.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" 
             @click="toggleExpand(scope.row)"
             style="cursor: pointer; margin-right: 5px;"></i></span>
        <span v-else-if="scope.row.type === '利润额'"></span>
        <span v-else>{{ getRowIndex(scope.row) }}</span>
      </template>
    </el-table-column>
    <el-table-column
      v-if="selection"
      type="selection"
      :selectable="selectable"
      fixed
      :reserve-selection="reserveSelection"
      align="center"
      width="50"
    ></el-table-column>
    <el-table-column
      v-for="(item, index) of tableColumnData"
      :key="index"
      :align="item.align || 'center'"
      resizable
      :min-width="minWidth ? minWidth : ''"
      :width="item.width ? item.width : ''"
      :prop="item.prop"
      :sortable="item.sortable ? 'custom' : false"
      :formatter="item.formatter"
      :fixed="item.fixed"
      :label="item.label"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        <div v-if="item.prop === 'type' && ['成本费用合计', '利润额', '资产合计'].includes(scope.row.type)">
          <!-- <i :class="scope.row.expanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'" 
            @click="toggleExpand(scope.row)" 
            style="cursor: pointer; margin-right: 5px;"></i> -->
          <span class="bold fz-16">{{ scope.row[item.prop] }}</span>
        </div>
        <span v-else-if="item.type === 'LINK' && !unLink" @click="click(scope.row, item.prop)" class="common-table-click pointer">{{scope.row[item.prop]}}</span>
        <div v-else-if="item.type === 'OPERATE'" class="common-table-control">
          <div
            v-for="(value, index) of item.controls"
            :key="index"
            class="common-table-click pointer"
            @click="clickcontrol(scope.row, value.prop)"
          >
            <p v-if="!value.disappear">{{`${value.label}`}}</p>
          </div>
        </div>
        <span v-else-if="item.type === 'DATETIME'">{{ dateTime(scope.row[item.prop]) }}</span>
        <span v-else-if="item.type === 'DATE'">{{ date(scope.row[item.prop]) }}</span>
        <span v-else-if="item.type === 'MONEY'">{{ dealWithMoney(scope.row[item.prop]) }}</span>
        <span v-else-if="item.type === 'MONEY2_PERCENT'">{{ dealWithMoneyOrPercent(scope.row[item.prop]) }}</span>
        <span v-else-if="item.type === 'MONEY2'">{{ dealWithMoney2(scope.row[item.prop]) }}</span>
        <span v-else-if="item.type === 'PERCENT'">{{ dealWithPercent(scope.row[item.prop]) }}</span>
        <span v-else-if="item.type === 'AREA'">{{ scope.row[item.prop] | areaFormat }}</span>
        <span v-else-if="item.type === 'DATEPERIOD'">{{ scope.row[item.prop].join('-') }}</span>
        <span v-else-if="item.type === 'CUSTOM'">
          <slot :name="item.prop" :scope="scope"></slot>
        </span>
        <span
          v-else-if="item.type === 'ENUM'"
        >{{ scope.row[item.prop] ? scope.row[item.prop].name : '' }}</span>
        <span v-else-if="item.type === 'BOOLEAN'">{{ transferNumberToBool(scope.row[item.prop]) }}</span>
        <span v-else-if="item.type === 'ARRAY'">{{ scope.row[item.prop].join(item.divide || '/') }}</span>
        <span v-else-if="item.type === 'HOUR'">
          <!-- {{ (scope.row[item.prop] / 60.0).toFixed(1) }} -->
          {{ `${parseInt(scope.row[item.prop] / 60, 10)}时${(scope.row[item.prop] % 60).toFixed(0)}分` }}
        </span>
        <span v-else-if="item.type === 'SCORE'">{{ (scope.row[item.prop] / 100.0).toFixed(2) }}</span>
        <span v-else-if="item.type === 'CHANGE'">{{change(scope.row[item.prop]) }}</span>
        <span
          v-else-if="item.type === 'APPROVESTATUS'"
          class="dot blue"
          :class="color[scope.row[item.prop].id]"
        >{{scope.row[item.prop].name}}</span>
        <button
          v-else-if="item.type === 'OPERATION'"
          class="el-button el-button--text el-button--small"
          v-on:click="load(scope.row)"
          ref="load"
        >{{ opera(scope.row[item.prop]) }}</button>
        
        <span :class="{bold: ['成本费用合计', '利润额', '资产合计'].includes(scope.row.type)}" v-else>{{  getCellValue(scope.row, item.prop, item.formatter) }}</span>
        <!-- <span v-else>{{scope.row[item.prop]!== null && scope.row[item.prop]!== '' ? scope.row[item.prop] : '--'   }}</span> -->
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
// import { get } from "lodash"
/**
 * @file 自定义通用table组件
 * @author jiangjun
 *
 * @description
 * 字段type  OPERATION  :  操作指令
 *         LINK : 可点击
 *         OPERATE : 操作
 *         DATE : 日期
 *         DATETIME : 日期时间
 *         MONEY : 钱
 *         PIC&LINK : 带图片，可点击
 *         CUSTOM : 自定义，需传递slot，自定义样式中，已将表格数据scope传递，接收方需使用 slot-scope="{ scope }"来接收表格当前行数据
 * 其他为默认样式，不传type
 *
 * @prop {array} tableColumnData 表头配置
 *       [{ label: '', prop: '', 'type': '', controls: [{label:'操作项时才需要', prop: '', disappear: boolean}]}]
 * @prop {array} data 数据
 * @prop {boolean} selection 是否显示选择器
 * @prop {function} selectable 选择器显示规则
 *
 * @event clicklink 表格内可点击的事件 回传（value: object, prop: string)：当前行的数据value，当前列的prop
 * @event clickcontrol 操作栏点击事件 回传（value: object, prop: string)：当前行的数据value，操作项的prop
 * @event selectionChange selection点击回传事件 回传(value: array)：选中的数据数组
 * @event sortChange 排序点击回传事件 回传(prop: string, type: number)：需要回传的porp，type: 升序（1）/降序（2）
 */

// 排序时回传排序状态映射
const orderType = {
  ascending: 1,
  descending: 2
};

export default {
  props: {
    tableColumnData: {
      type: Array,
      default: () => []
    },
    noIndex: {
      type: Boolean,
      default: false
    },
    selection: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      // 输入属性为对象或数组的时候需要使用此种方式
      default: () => []
    },
    highlightRow: {
      type: Boolean,
      default: true
    },
    maxHeight: {
      type: Number,
      default: null
    },
    minWidth: {
      type: String,
      default: ""
    },
    selectable: {
      type: Function,
      default: () => true
    },
    border: {
      type: Boolean,
      default: true
    },
    reserveSelection: {
      type: Boolean,
      default: false
    },
    unLink: {
      type: Boolean,
      default: false
    },
    showSummary: { // 是否展示合计
      type: Boolean,
      default: false, 
    },
    getElSummaries: {
    },
    spanMethod: {
    }
  },
  data() {
    return {
      color: {
        2: "yellow",
        3: "green",
        4: "red",
        7: "red"
      }
    };
  },
  methods: {
    click(value, prop) {
      this.$emit("clicklink", value, prop);
    },
    clickcontrol(value, prop) {
      this.$emit("clickcontrol", value, prop);
    },
    selectionChange(value) {
      this.$emit("selectionChange", value);
    },
    sortChange(val) {
      this.$emit("sortChange", val.prop, orderType[val.order]);
    },
    /**
     * @description 用于表格中一级二级三级菜单颜色变化显示
     * @author wangjiaqun 044033
     * @param {Object} row 行对象
     * @return 类控制器名称
     */
    tableRowClassName({ row, rowIndex }) {
      if (row.levelId === "1") {
        return "level-one";
      } else if (row.levelId === "2") {
        return "level-two";
      }
      return "";
    },
    dateTime(value) {
      if (value && value !== "未生成代码") {
        return this.$options.filters.formatDate(value, "yyyy-MM-dd HH:mm:ss");
      } else {
        return "未生成代码";
      }
    },
    transferNumberToBool(value) {
      if (value == 0 || value == false) {
        return "否";
      } else if (value == 1 || value == true) {
        return "是";
      } else {
        return "--";
      }
    },
    date(value) {
      if (value && value !== "--") {
        return this.$options.filters.formatDate(value, "yyyy-MM-dd");
      } else {
        return "--";
      }
    },
    // 用于切换选中的项
    toggleRowSelection(row, value) {
      this.$refs.table.toggleRowSelection(row, value);
    },
    // selectable(row, index) {
    // }
    dealWithMoney(value) {
      if (!value) {
        return "--";
      } else {
        return this.$options.filters.currency(
          this.$options.filters.unitMoney(value, 1),
          "￥",
          2
        );
      }
    },
    dealWithMoney2(value) {
      if (!value && value !== 0 && value !== '0' && value !== 0.0 && value !== '0.0' && value !== 0.00 && value !== '0.00') {
        return "--";
      } else {
        return this.$options.filters.currency(
          this.$options.filters.unitMoney(value, 1),
          "￥",
          2
        );
      }
    },
    dealWithMoneyOrPercent( val ) {
      if(!!val ) {
        const MoneyOrPercent = val.split('_')
          // 392 113产品毛利率  396 117经营利润率===>展示%
        if(MoneyOrPercent[1] === 392 || MoneyOrPercent[1] === '392' || MoneyOrPercent[1] === 396 ||MoneyOrPercent[1] === '396' ) {
          return this.dealWithPercent(MoneyOrPercent[0])
        } else {
          return this.dealWithMoney2(MoneyOrPercent[0])
        }
      } else {
        return '--'
      }
    },
    dealWithPercent(value) {
      if (!!!value) {
        return "--";
      } else {
        return this.$options.filters.currency(
          this.$options.filters.unitMoney(value, 1),
          "",
          2
        ) + '%';
      }
    },
    opera(value) {
      if (value === "1") {
        return "下载代码";
      } else {
        return "-";
      }
    },
    change(value) {
      if (value === "1") {
        return "下拉框1";
      } else if (value === "2") {
        return "下拉框2";
      } else {
        return "-";
      }
    },
    load(value) {
      this.$emit("load", value);
    },
    getCellValue(item, path, formatter) {
        const EMPTY_PLACEHOLDER = '--'
        let safeValue = item[path]!== null && item[path]!== '' ? item[path] : '--'  
        return formatter ? (safeValue !== EMPTY_PLACEHOLDER ? formatter(safeValue) : safeValue) : safeValue
    },
    toggleExpand(row) {
      if (row.type === '成本费用合计') {
        this.$set(row, 'expanded', !row.expanded);
        const index = this.data.findIndex(item => item === row);
        for (let i = index + 1; i < this.data.length; i++) {
          if (this.data[i].type === '利润额' || this.data[i].type === '资产合计') break;
          this.$set(this.data[i], 'visible', row.expanded);
        }
      } else if (row.type === '资产合计') {
        this.$set(row, 'expanded', !row.expanded);
        const index = this.data.findIndex(item => item === row);
        for (let i = index + 1; i < this.data.length; i++) {
          this.$set(this.data[i], 'visible', row.expanded);
        }
      }
    },
    getRowIndex(row) {
      const visibleRows = (this.data || []).filter(item => item.visible !== false)
      let count = 0
      for (let i = 0; i < visibleRows.length; i++) {
        const current = visibleRows[i]
        if (current.type !== '成本费用合计' && current.type !== '利润额' && current.type !== '资产合计') {
          count++
        }
        if (current === row) {
          break
        }
      }
      return count
    }
  }
};
</script>

<style>
.el-table .level-one {
  background: rgba(210, 231, 251, 1);
}

.el-table .level-two {
  background: rgba(244, 250, 255, 1);
}
.el-table__body-wrapper::-webkit-scrollbar {
  width: 8px; /* 设置滚动条宽度 */
  height: 8px; /* 设置滚动条宽度 */
}
.el-table .expanded-row {
  background-color: #f5f7fa;
}
.bold {
  font-weight: 700;
}
.fz-16 {
  /* font-size: 16px; */
}
</style>
